/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import {
  JobAttachment,
  JobDueDate,
  JobFacility,
  JobFrequencyForJobSummary,
  JobService,
  JobStatus,
  JobVendor,
  SubJobsForJobSummary,
} from '../../../API';

export enum ShiftTypes {
  Day = 'Day',
  DayAndNight = 'Day & Night',
  Night = 'Night',
}

export interface IJobData {
  address: any;
  id: number;
  facilityName: string;
  facilityId: string;
  jobId: string;
  location: string;
  FacilityIcon: string;
  buildingName: string;
  Jobname: string;
  startTime: string;
  endTime: string;
  vendorId: string;
  customerId?: string;
}

export interface IServices {
  id: number;
  serviceName: string;
  mdServiceId: string;
  iconUrl: string;
  shiftType: string;
  shiftTiming: string;
}
[];

export interface IVendorDetails {
  vendorPersonName: string;
  vendorPersonIcon: string;
  vendorName: string;
  vendorLocation: string;
  VendorPersonMailId: string;
  vendorContactNumber: string;
}

export interface IPerformanceMetrics {
  totalTasks: number;
  completed: number;
  inComplete: number;
  punchInTime: string;
  punchOutTime: string;
  inspectionScore: number;
  title: string;
  issuesRaised: number;
  oneTimeJobs: number;
  days?: string;
}

export type JobSummaryV2Data = {
  __typename: 'JobSummaryV2';
  jobId: string;
  actualId?: string | null;
  jobName: string;
  specialInstructions?: string | null;
  startDate?: string | null;
  stopDate?: string | null;
  jobType?: string | null;
  customerId?: string | null;
  customerName?: string | null;
  jobCustodian?: string | null;
  dataStatus?: JobStatus | null;
  jobFacilities?: Array<JobFacility | null> | null;
  jobServices?: Array<JobService | null> | null;
  jobFrequencies?: Array<JobFrequencyForJobSummary | null> | null;
  jobVendors?: Array<JobVendor | null> | null;
  jobDueDates?: Array<JobDueDate | null> | null;
  jobAttachments?: Array<JobAttachment | null> | null;
  subJobs?: Array<SubJobsForJobSummary | null> | null;
  isPaid?: boolean | null;
  jobRating?: number | null;
  isFlow2OrFlow3Job?: boolean;
  totalAmount?: number;
  actualEndDate?: string | null;
  workTicketNo?: string | null;
  status?: JobStatus | null;
  workTicketStatus?: number;
};

export type FacilityAccessData = {
  accessCode?: string;
  otherInformation?: string;
  username?: string;
  phoneNumber?: string;
};
